import { Component, ElementRef, ViewChild } from "@angular/core";
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { environment } from "../environments/environment";
import { EventMessage, InteractionStatus, EventType } from "@azure/msal-browser";
import { Subject, Subscription, filter, takeUntil } from "rxjs";
import { MsalService, MsalBroadcastService } from "@azure/msal-angular";
import { LoaderService, LoaderState } from "./service/loader.service";
import { HeaderComponent } from "./core/components/header/header.component";
import { SharedModule } from "./core/shared.module";
import { AppService } from "./service/app.service";
import { Utente } from "./interfaces/user";
import { MatSidenav } from "@angular/material/sidenav";

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  imports: [CommonModule, RouterModule, HeaderComponent, SharedModule,]
})
export class AppComponent {
  private subscribers = new Subscription();
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private loaderService: LoaderService,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private appService: AppService,
  ) { }
  isLoading = false;
  isIframe = false;
  env = environment;
  currentUser: any = [];
  utente: Utente = this.appService.user;
  @ViewChild('sidenavMenu') sidenav!: MatSidenav;
  @ViewChild('navbarNav') navbarNav!: ElementRef;

  get isHome() {
    return window.location.pathname === '/home';
  }
  get isResponsabileGerarchico() {
    return window.location.pathname.startsWith('/responsabile-gerarchico');
  }
  get isResponsabilePrimoLivello() {
    return window.location.pathname.startsWith('/responsabile-primo-livello');
  }
  get isResponsabileCommessa() {
    return window.location.pathname.startsWith('/responsabile-commessa');
  }
  get isPianificazioneControllo() {
    return window.location.pathname.startsWith('/pianificazione-controllo');
  }
  get isControllerBU() {
    return window.location.pathname.startsWith('/controller-bu');
  }
  get isControllerCentrale() {
    return window.location.pathname.startsWith('/controller-centrale');
  }
  get isCOO() {
    return window.location.pathname.startsWith('/coo');
  }
  get isCFO() {
    return window.location.pathname.startsWith('/cfo');
  }
  get isDirettoreGenerale() {
    return window.location.pathname.startsWith('/direttore-generale');
  }
  get isUnauthorizedOrError() {
    return window.location.pathname === '/unauthorized' || window.location.pathname === '/error-page';
  }
  get isNotFound() {
    return window.location.pathname === '/not-found';
  }
  get user() {
    return this.authService.instance.getAllAccounts()[0];
  }
  ngOnInit() {
    this.initLoader();
    this.msalInit();
    this.checkAndSetActiveAccount();
  }
  msalInit() {
    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/';
        } else {
          // this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((x) => {
        this.checkAndSetActiveAccount();
      });
  }

  initLoader() {
    const loaderCustom = document.getElementById('loader-custom');
    this.subscribers.add(
      this.loaderService.loaderState.subscribe((state: LoaderState) => {
        this.isLoading = state.show;
        if (state.show && loaderCustom) {
          loaderCustom.className = loaderCustom
            .className.replace('d-none', '');
        } else {
          if (loaderCustom &&
            !loaderCustom
              .className.includes('d-none')
          ) {
            loaderCustom.className =
              loaderCustom.className + ' d-none';
          }
        }
      })
    );
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  navigate(redirect: string) {
    if (window.location.pathname !== ('/' + redirect)) {
      this.loaderService.show();
    }
    this.sidenav.close();
    // this.closeMenu();
    this.router.navigate([redirect]);
  }

  closeMenu(): void {
    const navbar = this.navbarNav.nativeElement;
    if (navbar.classList.contains('show')) {
      navbar.classList.remove('show');
    }
  }

  ngOnDestroy() {
    this.subscribers.unsubscribe();
  }

}
